const green = '#2BB36F'
const red = '#ff5448'
const yellow = '#EAA800'

const colors = {
  primary: '#52BAE2',
  blue: '#52BAE2',
  green,
  greenToOrange: '#a4ba42',
  orangeToRed: '#ff8038',
  red,
  orange: '#FFC020',
  yellow,
  submission: {
    // Published/Under Review
    1: yellow,
    // Draft
    2: '#999999',
    // Need Revision
    3: red,
    // Approved
    4: green,
    // Trash
    5: '#999999',
    // Declined
    6: '#999999'
  },
  activity: {
    // Pre Activity
    1: yellow,
    // In Activity
    2: green,
    // Post Activity
    3: '#999999',
    // Completed
    4: '#999999',
    // Cancelled
    5: '#999999'
  },
  organization_backgrounds: [
    '#1F2657',
    '#D63288',
    '#54B1AB',
    '#7777BD',
    '#D14E3D',
    '#AD7A69',
    '#856439',
    '#606060',
    '#205DAD',
    '#F1993F'
  ]
}

export default colors
